type Props = {
  url: string;
  title: string;
  allowedFeatures: string;
  customStyles?: React.CSSProperties;
};

export const VideoPlayer = ({ url, title, allowedFeatures, customStyles }: Props) => {
  return (
    <iframe
      src={url}
      frameBorder='0'
      allow={allowedFeatures}
      referrerPolicy='strict-origin-when-cross-origin'
      style={customStyles}
      title={title}
    ></iframe>
  );
};
